<!--20211102 sea bert-->
<template>
  <div >
    
      <div class="organization_content">
         <div class="tabpane_container tabpane_container_act">
          

            <div class="form_content">
        <el-tabs v-model="activeIndex"  @tab-click="handleSelect">
            <el-tab-pane label="名称查询" name="0"></el-tab-pane>
            <el-tab-pane label="省市业务" name="1"></el-tab-pane> 
          </el-tabs> 
              <el-form
               v-show="activeIndex==0"
                label-position="right"
                label-width="100px"
                ref="ruleForm"
                :rules="rules"
                :model="formLabelAlign"
              >
                <el-form-item label="单位名称" prop="name">
                  <el-input
                    v-model="formLabelAlign.name"
                    class="inputclass"
                    clearable
                    placeholder="请输入单位名称"
                  ></el-input>
                </el-form-item> 
                <el-form-item>
                  <el-button class="formBtn" :disabled="loading" @click="onSubmit('ruleForm')">{{ loading ? '查询中...':'查询'}}</el-button> 
                </el-form-item>
              </el-form>


              <!-- 个人 省市 -->
              <el-form
               v-show="activeIndex==1"
                label-position="right"
                label-width="100px"
                ref="ruleForm2"
                :rules="rules"
                :model="formLabelAlign"
              > 
                <el-form-item label="省市地区" prop="areas">  
                  <el-cascader
                    :options="areaOptions"
                    :props="{ label: 'title',value:'key' }"
                    v-model="formLabelAlign.areas"
                    @change="handleAreaChange"
                    clearable
                    class="inputclass"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="业务类型"  prop="yewuName">
                  <el-select
                    v-model="formLabelAlign.yewuName"
                    :placeholder="'请选择业务类型'"
                    class="inputclass"
                    @change="onYewuConfirm"
                    clearable
                  >
                    <el-option
                      :label="value"
                      :value="value"
                      v-for="(value, key, index) in yewuColumns"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-show="subLabel" :label="subLabel"  prop="subValue">
                  <el-select
                    v-model="formLabelAlign.subValue"
                    :placeholder="'请选择'+subLabel"
                    class="inputclass"
                    clearable
                  >
                    <el-option
                      :label="value.name"
                      :value="value.value"
                      v-for="(value, index) in subColumns"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button class="formBtn"  :disabled="loading" @click="onSubmit2('ruleForm2')">{{ loading ? '查询中...':'查询'}}</el-button> 
                </el-form-item>
              </el-form>


            </div>
            <div class="default_right_pic" v-if="searchReault == -1"></div>
            <div class="search_result" v-else-if="searchReault==1">
              
                <div v-for="(item,k) in list" :key="k">
                    <van-divider>{{item.name}}</van-divider>

                    <van-cell-group  >
                        <van-cell title="单位" :value="item.row.danwei" />
                        <van-cell title="类型" :value="item.row.kaojitype" />
                        <van-cell title="日期" :value="item.row.registdate" />
                    </van-cell-group>

                </div>

                <div >

                    <van-cell-group v-for="(row,i) in list2" :key="i">
                        <van-cell title="单位" :value="row.danwei" />
                        <van-cell title="类型" :value="row.kaojitype" />
                        <van-cell title="日期" :value="row.registdate" />
                    </van-cell-group>

                </div>

            </div>
              <div
                class="search_result_nonthing"
                v-else-if="searchReault == 0"
              ></div>
          </div>
      </div>  
  </div>
</template>
<script>
export default {
  name: "SpecialTabs",
  props: { 
    activeName: {
      type: String,
      default: ''
    },
    areaOptions:{
      type: Array,
      default:[]
    },
  },
  data() {
    return {
      activeIndex:0,
      searchReault:-1,
      yewuColumns:[
                    '考级中心/点','先进学校'
      ],
      subColumns:[],
      subLabel:'',
      subOptions:[
            {
                name:'类型',
                list:[
                    {
                        name:'考级点',
                        value:1,
                    },
                    {
                        name:'考级中心',
                        value:2,
                    },
                ]
            },

            {
                name:'类型',
                list:[
                    {
                        name:'实验学校',
                        value:1,
                    },
                    {
                        name:'示范学校',
                        value:2,
                    },
                    {
                        name:'实验区',
                        value:3,
                    },
                    {
                        name:'示范区',
                        value:4,
                    },
                    {
                        name:'实验幼儿园',
                        value:5,
                    },

                    {
                        name:'示范幼儿园',
                        value:6,
                    },
                    {
                        name:'实验单位',
                        value:7,
                    },
                    {
                        name:'示范单位',
                        value:8,
                    }
                ]
            }
      ],
      
      formLabelAlign: {
        //表单数据
        name: "",
        num: "",
        grade: "", 
        yewuIndex:'',
        subValue:'',
        areas:[],
        area:'',
      },   
      loading:false,
      list:[],
      list2:[],
      rules: {
        name: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ], 
        subValue:[{ required: true, message: "请选择", trigger: "blur" }],
        areas:[{ required: true, message: "请选择地区", trigger: "blur" }],
        yewuName:[{ required: true, message: "请选择类型", trigger: "blur" }],
      },

    };
  },
  computed: {
    // tabListNew() {
    //   return {
    //     "--length": this.tabList.length
    //   };
    // }
  },
  methods: {
    handleSelect(){

    },
    handleAreaChange(value) {
      console.log('handleAreaChange',value);
      console.log('handleAreaChange',this.formLabelAlign.areas);
      this.formLabelAlign.area = this.formLabelAlign.areas[this.formLabelAlign.areas.length-1]
    },

    onSubmit(formName) {
      const that = this;
      console.log("formName");
      let url = '' 
        url = '/api/cha/danwei' 
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true;
          that.$api.post(
            url,
            that.formLabelAlign,
            (res) => { 
              that.list = res.data;
              that.loading = false;
              that.searchReault = 1;
            },
            (r) => {
              that.$message.error(r.msg);
              that.loading = false;
              that.searchReault = 0;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },  

    onSubmit2(formName) {
      const that = this;
      console.log("formName");
      let url = '' 
      url = '/api/cha/danweiArea' 
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true;
          that.$api.post(
            url,
            that.formLabelAlign,
            (res) => { 
              that.list2 = res.data;
              that.loading = false;
              that.searchReault = 1;
            },
            (r) => {
              that.$message.error(r.msg);
              that.loading = false;
              that.searchReault = 0;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },  
    onYewuConfirm(value){
      console.log('onYewuConfirm',value)
      // return ;
        // this.formData.yewuName = value;
        let index  = this.yewuColumns.indexOf(value);
        this.formLabelAlign.yewuIndex = index+1;
        this.subColumns = this.subOptions[index].list;
        this.subLabel = this.subOptions[index].name;
        // if(this.subOptions[this.formData.yewuIndex-1].list.length>0){
        //     this.formData.subName =  this.subOptions[this.formData.yewuIndex-1].list[0].name;
        //     this.formData.subValue =  this.subOptions[this.formData.yewuIndex-1].list[0].value
        // }else{
        //     this.formData.subName =  '';
        //     this.formData.subValue = 0;
        // }
        // this.showYewuPicker = false;
    },
  },
};
</script>
<style lang="scss" scoped>


.organization_content { 
  width: 1200px;
    // min-height: 803px;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 20px;
    margin: -27px auto 30px; 
}



  .tabpane_container { 
    // min-height: 1031px;   
    overflow: hidden;
  }
  .tabpane_container_act {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    .form_content { 
      width: 421px;
      height: 383px;
      background: #fff4ed;
      border-radius: 10px;
      padding: 16px;
      .inputclass {
        width: 240px;
        height: 40px;
      }
      /deep/.el-form-item__label {
        font-size: 16px;

        font-weight: 400;
        color: #000000;
        padding: 0 21px 0 0;
      }
      .formBtn {
        display: inline-block;
        width: 95px;
        border: none;
        // height: 40px;
        // line-height: 40px;
        background: #ff8d3a;
        border-radius: 10px;
        text-align: center;
        // margin: 10px 4px 0 0;

        font-size: 14px;

        font-weight: 400;
        color: #ffffff;
        &:hover {
          opacity: 0.95;
          font-weight: bold;
          cursor: pointer;
        }
      }
      .btn_tips {
        display: inline-block;
        font-size: 14px;

        font-weight: 400;
        color: #c8c9cc;
      }
    }
    .default_right_pic {
      width: 446px;
      height: 240px;
      background: red;
      margin: 109px 0 0 152px;
      // background: url("~@/assets/imgaes/listitem/") no-repeat center center;
      background: url("~@/assets/images/listitem/pic-相关查询-默认页图@2x.png")
        no-repeat;
      background-size: 100% 100%;
    }
    .search_result {
      margin: 32px 0 0 32px;
      width: 100%;
      max-height: 550px;
      overflow-y: scroll;
      .search_result_item {
        width: 723px;
        background: #f2f7ff;
        border-radius: 30px;
        margin: 0 0 32px 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        padding: 16px 0 16px 20px;
        .left_pic {
          width: 100px;
          height: 120px;
          object-fit: cover;
          border-radius: 8px;
        }
        .right_content {
          width: 559px;
          margin: 0 0 0 16px;
          .right_content_wrap {
            width: 100%;
            display: flex;
            flex-direction: row;
            .right_content_leftdata {
              flex: 1.1;
            }
            .right_content_rightdata {
              flex: 1;
            }
          }
          .right_content_lastline {
            width: 100%;
          }
          .right_content_line {
            flex: 1;
            height: 51px;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: 1px dashed #e5e5e5;
            box-sizing: border-box;
            .right_content_line_item {
              flex: 1;
              display: flex;
              flex-direction: row;
              .right_content_line_item_title {
                width: 122px;
                height: 20px;
                font-size: 14px;

                font-weight: 400;
                color: #999999;
                line-height: 20px;
                text-align: left;
              }
              .right_content_line_item_title_right {
                width: 100px;
              }
              .right_content_line_item_cont {
                text-align: left;
                height: 20px;
                font-size: 14px;

                font-weight: 400;
                color: #333333;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
  }
      .search_result_nonthing {
        width: 395px;
        height: 395px;
        background: url("~@/assets/images/listitem/pic-zihzisearch-none@2x.png")
          no-repeat center center;
        background-size: 100% auto;
        margin-left: 156px;
      }
</style>



// WEBPACK FOOTER //
// ChaDanwei.vue?94dad326